import { type FC, type ReactElement, Suspense, lazy } from 'react'

import { Loader } from '../components/Loader'
import { useRequireAuth } from '../hooks/useRequireAuth'
import { updatePlatformHeader } from '../services/api/auth'
import { setPlatformForLogs } from '../services/datadog'

const LazyConnectionsManagementPage = lazy(() =>
  import('../pages/ConnectionsManagement/ConnectionsManagementPage').then((module) => ({
    default: module.ConnectionsManagementPage,
  })),
)

export const ConnectionsManagementAndroidRoute: FC = (): ReactElement => {
  const platform = 'android'

  updatePlatformHeader(platform)
  setPlatformForLogs(platform)

  const { isAuthenticated } = useRequireAuth()

  if (!isAuthenticated) {
    return <Loader />
  }

  return (
    <Suspense fallback={<Loader />}>
      <LazyConnectionsManagementPage showBackButton={false} />
    </Suspense>
  )
}
